<template>
    <div id="dashboard-card">
        <v-card
            :min-height="size === 'l' ? 150 : ''"
            :class="`${reverseColor ? 'primary' : ''} rounded-xl dashboard-card shadow-lg bg-opacity-60`"
            @click="redirection"
            :color="color + ' lighten-2'"
        >
            <template v-if="size === 'l'">
                <v-card-text>
                    <div>
                        <v-row class="ma-0">
                            <v-col cols="6">
                                <v-icon :color="`${reverseColor ? 'white' : 'blue'}`" large>{{ icon }}</v-icon>
                            </v-col>
                            <v-col v-if="append_inner" class="d-flex justify-end" cols="6">
                                <v-chip class="white--text" :color="append_inner_color">{{ append_inner }}</v-chip>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="pl-2">
                        <p :class="`${reverseColor ? 'white--text' : ''} font-20 font-weight-medium mb-0`">{{ title }}</p>
                        <span :class="`${reverseColor ? 'text-reverse' : 'text'} `">{{ text }}</span>
                        <span :class="`${reverseColor ? 'text-reverse' : 'text'} font-weight-bold red--text` ">{{ sub_text }}</span>

                    </div>
                </v-card-text>
            </template>

            <template v-else>
                <div class="px-2 py-4">
                    <div>
                        <v-row class="ma-0">
                            <v-col :cols="append_inner ? 9 : 12" class="py-0">
                                <div class="d-flex align-start gap-2">
                                    <v-icon class="pt-1" color="blue" small>{{ icon }}</v-icon>

                                    <div>
                                        <p class="font-14 font-weight-medium mb-0">{{ title }}</p>
                                        <p class="text mb-0">{{ text }}</p>
                                        <p class="text mb-0 font-weight-bold red--text">{{ sub_text }}</p>

                                    </div>
                                </div>
                            </v-col>
                            <v-col v-if="append_inner" class="d-flex justify-end py-0" cols="3">
                                <v-chip class="white--text" :color="append_inner_color">{{ append_inner }}</v-chip>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </template>
        </v-card>
    </div>
</template>

<script>
import userRepository from '@/repositories/UserRepository'

export default {
    name: 'DashboardCard',
    props: {
        title: {
            type: String,
            require: true,
        },
        text: {
            type: String,
            require: true,
        },
        sub_text: {
            type: String,
            require: false,
        },
        icon: {
            type: String,
            require: true,
        },
        reverseColor: {
            type: Boolean,
            default: false,
            require: false,
        },
        link: {
            type: String,
            require: true,
        },
        append_inner: {
            type: String,
            require: false,
        },
        append_inner_color: {
            type: String,
            require: false,
            default: 'red',
        },
        size: {
            type: 'm' | 'l',
            require: false,
            default: 'l',
        },
        color: {
            type: String,
            default: 'white'
        }
    },
    methods: {
        redirection() {
            if (this.link === 'install_device') {
                window.open(process.env.VUE_APP_INSTALLATION_URL)
                return
            } else if (this.link === 'install_device_v2') {
                userRepository
                    .getTokenV2()
                    .then((success) => {
                        window.location.href = process.env.VUE_APP_INSTALLATION_V2_URL + '?token=' + success.data.data + '&space=user_admin'
                    })
                    .catch((error) => {
                        this.manageError(error)
                    })
                return
            }
            else if (this.link === 'access_test_network') {
                userRepository
                    .getTokenV2()
                    .then((success) => {
                        window.location.href = process.env.VUE_APP_INSTALLATION_V2_URL + 'network_coverage?token=' + success.data.data + '&space=user_admin'
                    })
                    .catch((error) => {
                        this.manageError(error)
                    })
                return
            }
            else if (this.link === 'search_by_site') {
                userRepository
                    .getTokenV2()
                    .then((success) => {
                        window.location.href = process.env.VUE_APP_ADMIN_V2_URL + '?redirection=site_sav&&token=' + success.data.data
                    })
                    .catch((error) => {
                        this.manageError(error)
                    })
                return
            } else if (this.link === 'public_reboot_tekelek') {
                window.open('https://public.fourdata.io/rebootTekelek')
                return
            } else if (this.link === 'interventions') {
                userRepository
                    .getTokenV2()
                    .then((success) => {
                        window.location.href =
                            process.env.VUE_APP_ADMIN_V2_URL + '?redirection=intervention&hash=installer&token=' + success.data.data
                    })
                    .catch((error) => {
                        this.manageError(error)
                    })
                return
            }
            this.$router.push(this.link)
        },
    },
}
</script>

<style>
.dashboard-card:hover {
    box-shadow: none !important;
    background: #eceff2 !important;
    translate: -2px 2px !important;
}
</style>
